import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CYCLE_EVENTS_CRUD_ACTION_CREATORS } from '../actions/cycle_events_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import CycleEventPipeLineFilters from '../components/AdminCycleEventsIndexPage/CycleEventPipelineFilters';
import { message } from 'antd';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

export const cycleEventsRestCrudThunksForBuyer = new RestCrudThunks(
	'asset_cycle_count_events',
	'cyclerun',
	'cyclerun',
	'asset_cycle_count_events',
	CYCLE_EVENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'asset/'
);
export const cycleEventsRestCrudThunksForSupplier = new RestCrudThunks(
	'asset_cycle_count_events',
	'cyclerun',
	'cyclerun',
	'asset_cycle_count_events',
	CYCLE_EVENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'asset/'
);

export const refreshCycleEventCounts = (roleType) => (filters) => (dispatch) => {
	const apiUrl = `/api/v1/${roleType}/asset/asset_cycle_count_events/count_by_status`;

	const data = {
		...(filters || {}),
		statuses: CycleEventPipeLineFilters.map((_) => _.name).join(','),
		status: undefined,
	};
	fetchUtils
		.get(
			BASE_URL + apiUrl,
			Object.assign(
				{
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				},
				data
			)
		)
		.then(parseJSON)
		.then(({ json, status, ok }) => {
			const d = json;
			if (d.status === 'error') {
				message.error(d.message);
			} else {
				if (d.data && d.data.length > 0) {
					d.data.map((category) =>
						dispatch(
							CYCLE_EVENTS_CRUD_ACTION_CREATORS.countBySuccess(
								category.count,
								category.categoryName
							)
						)
					);
				}
			}
		})
		.catch((d) => {
			message.error(d.message);
		});
};
